module.exports = __webpack_public_path__ + "img/m-kucunliebiao.d8424046.svg";